import { useMemo, useState } from 'react';

interface FilterConfig<T, TFilters> {
  items: T[];
  initialFilters: TFilters;
  predicate: (item: T, filters: TFilters) => boolean;
}

export function useTableFilter<T, TFilters>({
  items,
  initialFilters,
  predicate,
}: FilterConfig<T, TFilters>) {
  const [filters, setFilters] = useState<TFilters>(initialFilters);
  const [filterAnchor, setFilterAnchor] = useState<HTMLElement | null>(null);

  const openFilters = (e: React.MouseEvent<HTMLElement>) => setFilterAnchor(e.currentTarget);
  const closeFilters = () => setFilterAnchor(null);

  const filteredItems = useMemo(() => {
    return items.filter((item) => predicate(item, filters));
  }, [items, filters, predicate]);

  return {
    filters,
    setFilters,
    filterAnchor,
    setFilterAnchor,
    openFilters,
    closeFilters,
    isFiltersOpen: Boolean(filterAnchor),
    filteredItems,
  };
}